import React from 'react';

export default function Step5(props){
    return <div className="seehi_step">
        <h2>Financiering</h2>
        <p>U moet genoeg geld hebben om de rekening te betalen, omdat u de subsidie pas ontvangt nadat de werkzaamheden zijn uitgevoerd en betaald. Er zijn speciale leningen met lage rente voor energiebesparende maatregelen aan woningen en misschien kunt u gebruik maken van subsidieregelingen bij uw gemeente of provincie. Raadpleeg onderstaande bronnen voor meer informatie hierover.</p>
        <h3>Meer informatie</h3>
        <ul className="seehi_linklist">
            <li><a href="https://www.energiesubsidiewijzer.nl/" target="_blank">EnergieSubsidiewijzer</a><br />
                <em>Ontdek in twee stappen of er subsidies en aantrekkelijke leningen zijn om uw woning energiezuiniger te maken.</em>
            </li>
            <li><a href="https://www.energiebespaarlening.nl" target="blank">Energiebespaarlening</a><br />
                <em>Met de gunstige Energiebespaarlening van het Nationaal Energiebespaarfonds kunt u energiebesparende maatregelen voor uw woning financieren.</em>
            </li>
        </ul>

    </div>;
}


// WEBPACK FOOTER //
// ./src/steps/step5.js